import { render, staticRenderFns } from "./SwitchingCentre.vue?vue&type=template&id=7a28fc4c&"
import script from "./SwitchingCentre.vue?vue&type=script&lang=js&"
export * from "./SwitchingCentre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports